<template>
	<div>
		<v-tabs v-model="tab" background-color="transparent" grow centered>
			<v-tab v-tooltip.bottom="modoAyuda && $help.mantenimiento.statusMantenimientos.mantEncurso" v-if="mostrarVista('mantenimiento-historial')" @click="mantenimientosCursoClick">
				Mantenimientos<br />En Curso
			</v-tab>

			<v-tab v-tooltip.bottom="modoAyuda && $help.mantenimiento.statusMantenimientos.mantRealizados" v-if="mostrarVista('mantenimiento-historial')" @click="mantenimientosClick">
				Mantenimientos<br/>Realizados
			</v-tab>

			<v-tab v-tooltip.bottom="modoAyuda && $help.mantenimiento.statusMantenimientos.insCurso" v-if="mostrarVista('mantenimiento-inspecciones')" @click="inspeccionesCursoClick">
				Inspecciones<br />En Curso
			</v-tab>

			<v-tab v-tooltip.bottom="modoAyuda && $help.mantenimiento.statusMantenimientos.insRealizadas" v-if="mostrarVista('mantenimiento-inspecciones')" @click="inspeccionesClick"> Inspecciones<br/>Realizadas </v-tab>

			<v-tabs-items v-model="tab" touchless>
				<v-tab-item eager>
					<Mantenimientos ref="mantCurso" />
				</v-tab-item>

				<v-tab-item eager>
					<Historial ref="hist" />
				</v-tab-item>

				<v-tab-item eager>
					<Inspecciones ref="insCurso" />
				</v-tab-item>
				<v-tab-item eager>
					<InspeccionesTerminadas ref="ins" />
				</v-tab-item>
			</v-tabs-items>
		</v-tabs>
	</div>
</template>

<script>
import Historial from "./Historial.vue";
import InspeccionesTerminadas from "./InspeccionesTerminadas.vue";
import Inspecciones from "./EnCurso/Inspecciones.vue";
import Mantenimientos from "./EnCurso/Mantenimientos.vue";
import { mapState } from 'vuex';

export default {
	components: {
		Historial,
		InspeccionesTerminadas,
		Mantenimientos,
		Inspecciones,
	},
	data: () => ({
		tab: 0,
	}),
	mounted:{
		...mapState(["modoAyuda"])
	},
	methods: {
		initialize() {
			this.mantenimientosCursoClick();
            this.mantenimientosClick();
            this.inspeccionesCursoClick();
            this.inspeccionesClick();
		},
		mantenimientosCursoClick() {
			if (typeof this.$refs.mantCurso === "undefined") return;
			this.$refs.mantCurso.initialize();
		},
		mantenimientosClick() {
			if (typeof this.$refs.hist === "undefined") return;
			this.$refs.hist.initialize();
		},
		inspeccionesCursoClick() {
			if (typeof this.$refs.insCurso === "undefined") return;
			this.$refs.insCurso.initialize();
		},
		inspeccionesClick() {
			if (typeof this.$refs.ins === "undefined") return;
			this.$refs.ins.initialize();
		},
	},
};
</script>